import { KPI_COMPONENTS, Kpi, KpiCalculationParams, KpiConfig, KpiConfigMeta } from '../../../../types';
import { format } from './kpi-formatter';

export class CountOfActiveCompaniesConfig implements KpiConfig {
  private id = KPI_COMPONENTS.COUNT_OF_ACTIVE_COMPANIES as const;
  private title = 'Active Companies';
  private type = 'integer';

  getMeta(): KpiConfigMeta {
    return {
      id: this.id,
      title: this.title,
      type: this.type,
    };
  }

  calculate({ data }: KpiCalculationParams): Kpi {
    const value =
      data?.metrics
        .filter(({ transactions, activeStatus }) =>
          transactions.some(
            ({ investmentAmount, transactionDate }) =>
              investmentAmount > 0 && new Date(transactionDate) < data.date && activeStatus === 'Active'
          )
        )
        .reduce((res, metrics) => {
          return res.add(metrics.companyId);
        }, new Set()).size ?? 0;

    return {
      ...this.getMeta(),
      value,
      formatted: format(value, this.type),
    };
  }
}
